import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/search.svg'
import _imports_1 from '@/assets/icons/openlistdetails.svg'
import _imports_2 from '@/assets/icons/pagefirstenabled.svg'
import _imports_3 from '@/assets/icons/pagefirstdisabled.svg'
import _imports_4 from '@/assets/icons/pagelastenabled.svg'
import _imports_5 from '@/assets/icons/pagelastdisabled.svg'


const _hoisted_1 = { class: "companycontroltext" }
const _hoisted_2 = { class: "utils" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"25px"},
  alt: "searchimg",
  title: "searchimg"
}, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"25px"},
  alt: "listdetailsimg",
  title: "listdetailsimg"
}, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "pagingdiv"
}
const _hoisted_10 = { class: "pagelabel" }
const _hoisted_11 = {
  key: 0,
  src: _imports_2,
  style: {"width":"20px"},
  alt: "firstpageimg",
  title: "firstpageimg"
}
const _hoisted_12 = {
  key: 1,
  src: _imports_3,
  style: {"width":"20px"},
  alt: "firstpagedisabledimg",
  title: "firstpagedisabledimg"
}
const _hoisted_13 = {
  key: 0,
  src: _imports_4,
  style: {"width":"20px"},
  alt: "lastpageimg",
  title: "lastpageimg"
}
const _hoisted_14 = {
  key: 1,
  src: _imports_5,
  style: {"width":"20px"},
  alt: "lastpagedisabledimg",
  title: "lastpagedisabledimg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.showOptions)
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              id: "companysearch",
              modelValue: _ctx.companySearchVal,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companySearchVal) = $event)),
              placeholder: "Search",
              type: "search",
              class: "rightmargin inpstyle"
            }, {
              suffix: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      id: "companiestable",
      data: _ctx.companyList,
      style: {"width":"100%"},
      "max-height": "600px",
      "scrollbar-always-on": "",
      "header-cell-style": _ctx.headerstyle,
      onRowClick: _ctx.rowClickHandler,
      onSortChange: _ctx.handleSorting,
      "row-style": _ctx.rowdatastyle,
      "default-sort": { prop: 'name', order: 'aescending' },
      "empty-text": _ctx.nodatatxt
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "Company Name",
          prop: "companyName",
          sortable: ""
        }, {
          default: _withCtx((company) => [
            _createElementVNode("div", {
              class: _normalizeClass(company.row.expirationCount > 0 ? 'expiredlabel' : '')
            }, _toDisplayString(company.row.companyName), 3)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "License",
          align: "center",
          prop: "licenseCount",
          sortable: ""
        }, {
          default: _withCtx((props) => [
            (props.row.licenseCount === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "–"))
              : _createCommentVNode("", true),
            (props.row.licenseCount !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(props.row.licenseCount), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Credential-based Licenses",
          align: "center",
          prop: "subscriptionCount",
          sortable: ""
        }, {
          default: _withCtx((props) => [
            (props.row.subscriptionCount === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "–"))
              : _createCommentVNode("", true),
            (props.row.subscriptionCount !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(props.row.subscriptionCount), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "",
          width: "120"
        }, {
          default: _withCtx((company) => [
            _createVNode(_component_el_button, {
              onClick: ($event: any) => (_ctx.viewDetails(company)),
              plain: "",
              link: "",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style", "onRowClick", "onSortChange", "row-style", "empty-text"])), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.totalPages > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, [
            _createElementVNode("strong", null, "Page " + _toDisplayString(_ctx.currentPage) + " / " + _toDisplayString(_ctx.totalPages), 1)
          ]),
          _createVNode(_component_el_button, {
            plain: "",
            class: "paginationbtn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentPage = 1)),
            id: "firstpage",
            disabled: _ctx.currentPage === 1
          }, {
            default: _withCtx(() => [
              (_ctx.currentPage !== 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                : _createCommentVNode("", true),
              (_ctx.currentPage === 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_pagination, {
            layout: "prev, next",
            total: _ctx.totalRowsCount,
            "page-size": 10,
            "current-page": _ctx.currentPage,
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentPage) = $event))
          }, null, 8, ["total", "current-page"]),
          _createVNode(_component_el_button, {
            plain: "",
            class: "paginationbtn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentPage = _ctx.totalPages)),
            id: "lastpage",
            disabled: _ctx.currentPage === _ctx.totalPages
          }, {
            default: _withCtx(() => [
              (_ctx.currentPage !== _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                : _createCommentVNode("", true),
              (_ctx.currentPage === _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}